import React, { useEffect, useState } from "react";
import "react-simple-keyboard/build/css/index.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  CreateStaffUser,
  MailSent,
  MailSentApi,
  PendingData,
  login,
} from "../../services/redux/ApiActions";
import { useDispatch, useSelector } from "react-redux";
import { Authenticate } from "../../services/redux/AuthenticationReducer";
import { LoginUser } from "../../services/redux/LoginReducer";
import showNotification from "../../services/redux/NotifcationService";
import { startLoading } from "../../services/redux/loadingReducer";
import bowser from "bowser";
import logoPng from "../../img/logo.png";
import { Capacitor } from "@capacitor/core";
import EmailInput from "../reusableComponents/EmailInput";
import ORComponent from "../Common/ORComponent";
import { KeyboardComponent } from "../Common/KeyboardComponent";
import KeyboardImg from "../../img/keyboard.svg";
import { emailRegex } from "../Common/EmailRegex";
import RecaptchaComponent from "../Common/RecaptchaComponent";
import { jwtDecode } from "jwt-decode";
import Footer from "../Common/Footer";

const Login = () => {
  const [displayVirtualKeyboard, setDisplayVirtualKeyboard] = useState(false);
  const loginData = useSelector((state) => state.login);
  const successPage = useSelector((state) => state.successPage.successPage);
  const [recaptcha, setRecaptcha] = useState();
  const [userData, setUserData] = useState({
    email: "",
    password: "",
    screen: "email",
  });
  const location = useLocation();
  const action = location?.state; // Show only the last 4 digits for privacy
  const isAndroid = /Android/.test(navigator.userAgent);

  useEffect(() => {
    if (isAndroid) {
      // Your Android-specific logic here
      // console.log('This is an Android device.');
    } else {
      // Logic for other platforms
      // console.log('This is not an Android device.');
    }
  }, []);

  const hideShowKeyboard = () => {
    setDisplayVirtualKeyboard((prev) => !prev);
  };

  function onChangeCaptcha(value) {
    // console.log("Captcha value:", value);
    setRecaptcha(value);
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const Submit = async (event) => {
    event.preventDefault();
    const data = {
      email: userData.email,
      password: userData.password,
      code: "",
      isOtpNeeded: true,
      recaptchaValue: recaptcha,
    };
    if (userData.email === "") {
      showNotification("Email Field cannot be empty", "error");
    } else if (!emailRegex.test(userData.email)) {
      showNotification("Please enter a valid email", "error");
      return;
    } else if (userData.password === "") {
      showNotification("Password Field cannot be empty", "error");
    } else if (recaptcha === undefined) {
      showNotification("Captcha verification is required", "error");
    } else {
      const response = await dispatch(login(data));
      let decodedToken = jwtDecode(response.token_chr);
      // console.log(decodedToken)
      // Check token expiration
      const currentTime = Date.now() / 1000; // Convert to seconds
      if (decodedToken.exp < currentTime) {
        localStorage.clear();
        dispatch(Authenticate(false));
        showNotification("Session expired. Please login again.", "error");
        navigate("/login");
        return;
      }
      //new code
      // Extract data from decoded token claims
      const userId =
        decodedToken[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid"
        ];
      const email =
        decodedToken[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"
        ];
      const firstName =
        decodedToken[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname"
        ];
      const lastName =
        decodedToken[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname"
        ];
      const phoneNumber =
        decodedToken[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/mobilephone"
        ];
      const roles =
        decodedToken[
          "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
        ];

      // Reconstruct user object from token claims
      const userFromToken = {
        userId: userId,
        email: email,
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        roles: Array.isArray(roles) ? roles : [roles],
        token_chr: response.token_chr,
      };

      dispatch(LoginUser(userFromToken));

      if (response && response.token_chr) {
        if (Array.isArray(userFromToken.roles)) {
          const hasOnboardingStaffRole =
            userFromToken.roles.includes("OnboardingStaff");

          if (hasOnboardingStaffRole) {
            dispatch(startLoading(true));
            const userAgent = window.navigator.userAgent;
            const parsedInfo = bowser.parse(userAgent);

            const createStaff = async () => {
              dispatch(startLoading(true));
              const staffData = {
                v2pUserId: userFromToken.userId,
                fullName: `${userFromToken.firstName} ${userFromToken.lastName}`,
                email: userFromToken.email,
                phone: userFromToken.phoneNumber,
                createdBy: userFromToken.userId,
                createdIp: "",
                createdUserAgent: parsedInfo.browser.name,
              };

              dispatch(startLoading(true));
              const staff = await dispatch(
                CreateStaffUser(staffData, response.token_chr),
              );

              if (staff.statusCode === 200) {
                dispatch(Authenticate(true));
                dispatch(startLoading(false));
                showNotification("Login Successful", "success");
              }
            };

            createStaff();
            dispatch(startLoading(false));
          } else {
            showNotification(
              "You are not allowed to access this section",
              "error",
            );
          }
        }
      } else if (
        response.message &&
        response.message.toLowerCase().includes("otp")
      ) {
        const postedData = {
          email: userData.email,
          password: userData.password,
          screen: "email",
          userId: userFromToken.userId,
        };
        navigate("/otp", { state: { postedData } });
      }
      //new code above

      // JWT exp is in seconds
      // dispatch(LoginUser(response))
      // // console.log(response)
      // if (response) {
      //   if (response.token_chr) {
      //     if (response && response && Array.isArray(response.roles)) {
      //       const hasOnboardingStaffRole = response.roles.includes("OnboardingStaff");
      //       if (hasOnboardingStaffRole) {
      //         // console.log("User has the OnboardingStaff role.");
      //         dispatch(startLoading(true))
      //         const userAgent = window.navigator.userAgent;
      //         const parsedInfo = bowser.parse(userAgent);
      //         // console.log(parsedInfo.browser.name);
      //         const createStaff = async () => {
      //           const staffData = {
      //             "v2pUserId": response.userId,
      //             "fullName": response.firstName + " " + response.lastName,
      //             "email": response.email,
      //             "phone": response.phoneNumber,
      //             "createdBy": response.userId,
      //             "createdIp": "",
      //             "createdUserAgent": parsedInfo.browser.name
      //           }
      //           // console.log(loginData1)
      //           dispatch(startLoading(true))
      //           const staff = await dispatch(CreateStaffUser(staffData, response.token_chr));
      //           // console.log(staff)
      //           if (staff.statusCode === 200) {
      //             dispatch(Authenticate(true))
      //             dispatch(startLoading(false))
      //             showNotification('Login Successful', 'success')
      //             // const mailSentPayload = {
      //             //   "filter": "",
      //             //   "orderBy": "",
      //             //   "pageSize": 100,
      //             //   "pageNumber": 1
      //             // }
      //             // const mailSent = await dispatch(MailSentApi(mailSentPayload, response.token_chr));
      //             // if (mailSent) {
      //             //   dispatch(setMailSentData(mailSent))
      //             // }
      //           }
      //         }
      //         createStaff();
      //         dispatch(startLoading(false))
      //         // Do something if the user has the OnboardingStaff role
      //       } else {
      //         // console.log("User does not have the OnboardingStaff role.");
      //         showNotification("You are not allowed to access this section", 'error');
      //         // Do something if the user does not have the OnboardingStaff role
      //       }
      //     } else {
      //       // console.log("Response, result, or roles property is undefined or null.");
      //       // Handle the case where the response or its properties are missing
      //     }
      //   } else if (response.message.toLowerCase().includes('otp')) {
      //     const postedData = {
      //       email: userData.email,
      //       password: userData.password,
      //       screen: 'email',
      //       userId: response.userId
      //     }
      //     navigate('/otp', { state: { postedData } });
      //   }
      // }
    }
  };
  useEffect(() => {
    if (successPage === true) {
      navigate("/Customer/Success");
    }
  }, [successPage]);
  useEffect(() => {
    if (action?.action === "customerLogout") {
      navigate("/Customer/SessionExpired");
    }
  }, []);
  return (
    <div className="mailsentbody">
      <div className="logoBG">
        <div className="rightElement">
          <div className="flex min-h-full flex-col justify-center px-6 py-10 lg:px-8">
            <div className="">
              <div
                style={{
                  backgroundColor: `${Capacitor.isNative === true ? "transparent" : "white"}`,
                  padding: `${Capacitor.isNative === true ? "5px" : "20px"}`,
                }}
                className="rounded-lg  mt-5 sm:mx-auto sm:w-full md:max-w-md lg:max-w-lg"
              >
                <div className="space-y-6">
                  <div>
                    <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                      <img
                        className="mx-auto h-10 w-auto"
                        src={logoPng}
                        alt="Your Company"
                      />
                    </div>
                    <h2 className="pb-2 pt-2 text-center text-xl font-bold leading-9 tracking-tight text-gray-900">
                      STAFF LOGIN
                    </h2>
                    <p className="pb-2 text-md text-center text-gray-500">
                      Kindly enter your login credentials
                    </p>
                    <label
                      htmlFor="email"
                      className="block text-md font-medium leading-6 text-gray-900"
                    >
                      Email address
                    </label>
                    <div className="mt-2">
                      <EmailInput
                        value={userData.email}
                        name="email"
                        onChange={handleChange}
                        inputStyles={{
                          paddingLeft: "10px",
                          padding: "15px 10px",
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <div className="flex items-center justify-between">
                      <label
                        htmlFor="password"
                        className="block text-md font-medium leading-6 text-gray-900"
                      >
                        Password
                      </label>
                      <div className="text-sm">
                        {/* <a href="#" className="font-semibold text-indigo-600 hover:text-indigo-500">Forgot password?</a> */}
                        <img
                          onClick={hideShowKeyboard}
                          className="hover:cursor-pointer"
                          src={KeyboardImg}
                          style={{ width: "30px" }}
                        />
                      </div>
                    </div>
                    <div className="mt-2">
                      <KeyboardComponent
                        hideKeyboard={displayVirtualKeyboard}
                        userData={userData}
                        setUserData={setUserData}
                      />
                    </div>
                  </div>
                  <RecaptchaComponent onChangeCaptcha={onChangeCaptcha} />
                  <div>
                    <center>
                      <button
                        onClick={Submit}
                        type="submit"
                        className="flex w-10/12 justify-center rounded-md  px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                        style={{ backgroundColor: "#2E61A2" }}
                      >
                        Proceed
                      </button>
                    </center>
                  </div>
                </div>
                <ORComponent />
                {/* <ion-icon style={{ fontSize: '25px', marginBottom: '-5px', paddingRight: '10px' }} name="phone-portrait-outline"></ion-icon> */}
                <div className="flex justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3"
                    />
                  </svg>
                  <Link
                    to="/login/Mobile"
                    className=" text-base font-semibold leading-6 text-indigo-600 hover:text-indigo-500"
                  >
                    Login with mobile number
                  </Link>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
